export default ({
    btnAgregarMaterial:'Añadir material de apoyo',
    tituloCentroAyuda: 'Centro de ayuda',
    tituloComponenteHtmlEditor: 'Texto renderizado',
    subtituloCentroAyuda: 'Nuestros productos',
    subtituloCentroAyudaModulo: 'Nuestros módulos',
    subtituloMaterialApoyo: 'Material de apoyo',
    btnVer: 'ver',
    navDashboard: 'Dashboard',
    navVistaPrincipal: 'Vista Principal',
    navModulo: 'Módulo',
    navNuevaPregunta : 'Añadir material de apoyo',
    subtituloBienvenido : 'Bienvenido, ¿En qué te podemos ayudar?',
    textCualPregunta: '¿Cuál es tu pregunta?',
    btnVolver: 'Volver',
    textEncuesta: '¿Esta respuesta ha contestado tu inquietud?',
    textCalificacionExitosa: 'Gracias por calificarnos. Tu opinión es muy importante para nosotros',
    phFiltroCategoria: 'Seleccione Categoria',
    textResultadoBusqueda: 'Resultado de la búsqueda',
    textResultadosBusqueda: 'Resultados de la búsqueda',
    textCargando: ' Cargando información...'
})